import React from 'react';
import { Link } from 'gatsby';
import { TiSocialFacebook, TiSocialLinkedin, TiSocialPinterest, TiSocialTwitter } from 'react-icons/ti';

import { Col, Container, Row } from '../../../reusecore/Layout';
import Box from '../../../reusecore/Box';
import Text from '../../../reusecore/Text';
import Heading from '../../../reusecore/Heading';
import Sidebar from '../Blog-sidebar';
import ContentSections from '../../../pagebuilder/content-sections';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getGatsbyImageData } from 'gatsby-source-sanity';
import clientConfig from '../../../../../client-config';
import { useLocation } from '@gatsbyjs/reach-router';
import { Breadcrumbs } from '@material-ui/core';

import BlogPageWrapper from './blogSingle.style';
import BlockContent from '../../../block-content';

const BlogSinglePage = ({ page }) => {
  const { href, pathname } = useLocation();
  const { tags, heroImage, publishedAt, title, _rawBody } = page;
  let formattedDate = '';
  let formattedMonth = '';
  let formattedDay = '';
  if (publishedAt) {
    formattedDate = new Date(publishedAt);
    let month = formattedDate.getMonth() + 1;
    switch (month) {
      case 1: {
        formattedMonth = 'JAN';
        break;
      }
      case 2: {
        formattedMonth = 'FEB';
        break;
      }
      case 3: {
        formattedMonth = 'MAR';
        break;
      }
      case 4: {
        formattedMonth = 'APR';
        break;
      }
      case 5: {
        formattedMonth = 'MAY';
        break;
      }
      case 6: {
        formattedMonth = 'JUN';
        break;
      }
      case 7: {
        formattedMonth = 'JUL';
        break;
      }
      case 8: {
        formattedMonth = 'AUG';
        break;
      }
      case 9: {
        formattedMonth = 'SEP';
        break;
      }
      case 10: {
        formattedMonth = 'OCT';
        break;
      }
      case 11: {
        formattedMonth = 'NOV';
        break;
      }
      case 12: {
        formattedMonth = 'DEC';
        break;
      }
    }
    formattedDay = formattedDate.getDate() > 9 ? formattedDate.getDate() : '0' + formattedDate.getDate();
  }
  const gatsbyImageData = getGatsbyImageData(
    heroImage.image,
    { layout: 'constrained', maxWidth: 675 },
    clientConfig.sanity
  );
  return (
    <BlogPageWrapper>
      <Box className="single-post-wrapper">
        <Container>
          <div style={{ margin: '2rem auto' }}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link to="/blog">Blog</Link>
              <span>{title}</span>
            </Breadcrumbs>
          </div>
          <Row>
            <Col xs={12} lg={8}>
              <Row>
                <Col className="xs-12">
                  <Box className="single-post-block">
                    <Box className="post-thumb-block">
                      <GatsbyImage image={gatsbyImageData} alt={heroImage.alt} />
                      {publishedAt && (
                        <Box className="post-meta">
                          <Text as="span">
                            <Text as="em"> {formattedDay} </Text> {formattedMonth}
                          </Text>
                        </Box>
                      )}
                    </Box>
                    <Box className="post-content-block">
                      <Heading className="post-title">{title}</Heading>
                      {_rawBody && <BlockContent blocks={_rawBody} />}
                    </Box>
                    <Box className="post-info-block">
                      <Box className="single-page-tags">
                        {tags.map((tag) => {
                          return (
                            <Link key={tag.value} to={`/blog?tag=${tag.value.toLowerCase()}`}>
                              #{tag.label.toLowerCase()}
                            </Link>
                          );
                        })}
                      </Box>
                      <Box className="share">
                        Share
                        <a href={`https://www.facebook.com/sharer/sharer.php?u=${href}`} target={`_blank`}>
                          <TiSocialFacebook />
                        </a>
                        <a href={`https://twitter.com/share?url=${href}`} target={`_blank`}>
                          <TiSocialTwitter />
                        </a>
                        <a
                          href={`https://pinterest.com/pin/create/bookmarklet?media=${heroImage?.image?.asset.url}&url=${href}`}
                          target={`_blank`}
                        >
                          <TiSocialPinterest />
                        </a>
                        <a href={`https://linkedin.com/shareArticle?url=${href}`} target={`_blank`}>
                          <TiSocialLinkedin />
                        </a>
                      </Box>
                    </Box>

                    {/*<Box className="post-comment-wrapper">*/}
                    {/*  <Heading as="h2" className="block-title">*/}
                    {/*    5 Comments*/}
                    {/*  </Heading>*/}
                    {/*  <List>*/}
                    {/*    <ListItem>*/}
                    {/*      <Box className="post-comment-block">*/}
                    {/*        <Box className="author-avatar">*/}
                    {/*          <Image src={AuthorThumb2} alt="cryptik comments author" />*/}
                    {/*        </Box>*/}
                    {/*        <Box className="comment-body">*/}
                    {/*          <Box className="comment-body-inner">*/}
                    {/*            <Heading as="h3">*/}
                    {/*              Amrita<Text as="span">Dec, 05, 2020</Text>*/}
                    {/*            </Heading>*/}
                    {/*            <Box className="replay">*/}
                    {/*              <Link to="#">*/}
                    {/*                {' '}*/}
                    {/*                Replay <IoIosArrowRoundForward />{' '}*/}
                    {/*              </Link>*/}
                    {/*            </Box>*/}
                    {/*          </Box>*/}
                    {/*          <Box className="comment-content">*/}
                    {/*            <Text>*/}
                    {/*              Finalmente vol sol justamente crematorio vil nos. Bem com sido esse case alem aos.Amor*/}
                    {/*              tive fara de dado esse em.*/}
                    {/*            </Text>*/}
                    {/*          </Box>*/}
                    {/*        </Box>*/}
                    {/*      </Box>*/}
                    {/*      <List>*/}
                    {/*        <ListItem>*/}
                    {/*          <Box className="post-comment-block">*/}
                    {/*            <Box className="author-avatar">*/}
                    {/*              <Image src={AuthorThumb3} alt="cryptik comments author" />*/}
                    {/*            </Box>*/}
                    {/*            <Box className="comment-body">*/}
                    {/*              <Box className="comment-body-inner">*/}
                    {/*                <Heading as="h3">*/}
                    {/*                  {' '}*/}
                    {/*                  jacqueline <Text as="span">Dec, 05, 2020</Text>{' '}*/}
                    {/*                </Heading>*/}
                    {/*                <Box className="replay">*/}
                    {/*                  <Link to="#">*/}
                    {/*                    {' '}*/}
                    {/*                    Replay <IoIosArrowRoundForward />{' '}*/}
                    {/*                  </Link>*/}
                    {/*                </Box>*/}
                    {/*              </Box>*/}
                    {/*              <Box className="comment-content">*/}
                    {/*                <Text>*/}
                    {/*                  Finalmente vol sol justamente crematorio vil nos. Bem com sido esse case alem*/}
                    {/*                  aos.Amor tive fara de dado esse em.*/}
                    {/*                </Text>*/}
                    {/*              </Box>*/}
                    {/*            </Box>*/}
                    {/*          </Box>*/}
                    {/*        </ListItem>*/}
                    {/*        <ListItem>*/}
                    {/*          <Box className="post-comment-block">*/}
                    {/*            <Box className="author-avatar">*/}
                    {/*              <Image src={AuthorThumb4} alt="cryptik comments author" />*/}
                    {/*            </Box>*/}
                    {/*            <Box className="comment-body">*/}
                    {/*              <Box className="comment-body-inner">*/}
                    {/*                <Heading as="h3">*/}
                    {/*                  {' '}*/}
                    {/*                  Jennifer <Text as="span">Dec, 05, 2020</Text>{' '}*/}
                    {/*                </Heading>*/}
                    {/*                <Box className="replay">*/}
                    {/*                  <Link to="#">*/}
                    {/*                    {' '}*/}
                    {/*                    Replay <IoIosArrowRoundForward />{' '}*/}
                    {/*                  </Link>*/}
                    {/*                </Box>*/}
                    {/*              </Box>*/}
                    {/*              <Box className="comment-content">*/}
                    {/*                <Text>*/}
                    {/*                  Finalmente vol sol justamente crematorio vil nos. Bem com sido esse case alem*/}
                    {/*                  aos.Amor tive fara de dado esse em.*/}
                    {/*                </Text>*/}
                    {/*              </Box>*/}
                    {/*            </Box>*/}
                    {/*          </Box>*/}
                    {/*        </ListItem>*/}
                    {/*      </List>*/}
                    {/*    </ListItem>*/}
                    {/*    <ListItem>*/}
                    {/*      <Box className="post-comment-block">*/}
                    {/*        <Box className="author-avatar">*/}
                    {/*          <Image src={AuthorThumb5} alt="cryptik comments author" />*/}
                    {/*        </Box>*/}
                    {/*        <Box className="comment-body">*/}
                    {/*          <Box className="comment-body-inner">*/}
                    {/*            <Heading as="h3">*/}
                    {/*              {' '}*/}
                    {/*              William <Text as="span">Aug, 05, 2020</Text>{' '}*/}
                    {/*            </Heading>*/}
                    {/*            <Box className="replay">*/}
                    {/*              <Link to="#">*/}
                    {/*                {' '}*/}
                    {/*                Replay <IoIosArrowRoundForward />*/}
                    {/*              </Link>*/}
                    {/*            </Box>*/}
                    {/*          </Box>*/}
                    {/*          <Box className="comment-content">*/}
                    {/*            <Text>*/}
                    {/*              Finalmente vol sol justamente crematorio vil nos. Bem com sido esse case alem aos.Amor*/}
                    {/*              tive fara de dado esse em.*/}
                    {/*            </Text>*/}
                    {/*          </Box>*/}
                    {/*        </Box>*/}
                    {/*      </Box>*/}
                    {/*    </ListItem>*/}
                    {/*  </List>*/}
                    {/*</Box>*/}
                    {/*<Box className="comment-box-wrapper">*/}
                    {/*  <Heading as="h2" className="block-title">*/}
                    {/*    Leave a Comment*/}
                    {/*  </Heading>*/}
                    {/*  <Text>Sing in to post your comment or singup if you dont have any account.</Text>*/}
                    {/*  <form>*/}
                    {/*    <Box className="form-inline">*/}
                    {/*      <input type="text" placeholder="Name*" />*/}
                    {/*      <input type="email" placeholder="Email*" />*/}
                    {/*    </Box>*/}
                    {/*    <Box className="form-group">*/}
                    {/*      <input type="text" placeholder="Website(Optional)" />*/}
                    {/*    </Box>*/}
                    {/*    <textarea rows="10" cols="50" placeholder="Comment"></textarea>*/}
                    {/*    <Button>Post Comment</Button>*/}
                    {/*  </form>*/}
                    {/*</Box>*/}
                  </Box>
                </Col>
              </Row>
            </Col>
            <Col xs={12} lg={4}>
              <Sidebar />
            </Col>
          </Row>
          {page && page.content && <ContentSections content={page.content} />}
        </Container>
      </Box>
    </BlogPageWrapper>
  );
};

export default BlogSinglePage;
